import FormControls from 'component/FormControls';
import Page from 'component/Page';
import { useEffect, useState } from 'react';
// import { useSelector } from 'react-redux';
// import { selectCurrentUser } from 'redux/user/user.selector';
// import { ACCOUNT_ROLE_ADMIN } from 'util/permission';
import { Button, Form, Row } from 'react-bootstrap';
import { sendPost } from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import {
    focusElement,
    getFormData,
    showConfirm,
    showToast,
    nNU,
		getServiceCode,
    // serialValidate,
    // couponCodeValidate,
    // formatDate,
} from 'util/utils';

const ServiceCodeAdd = ({ data = { id: null, valid: true }, onUpdated }) => {
    //-------------------------------HOOKS-------------------------------------------------------------
    // const currentUser = useSelector(selectCurrentUser);
    //const [showPassword, setShowPassword] = useState(false);
    // const isAdmin = useMemo(
    //     () => currentUser.accountRole === ACCOUNT_ROLE_ADMIN,
    //     [ currentUser.accountRole ]
    // );
		const [serviceCode, setServiceCode] = useState(null);
		const [codeStr1, setCodeStr1] = useState(null);
		const [codeStr2, setCodeStr2] = useState(null);
		const [codeStr3, setCodeStr3] = useState(null);
		const [codeStr4, setCodeStr4] = useState(null);
		const [codeStr5, setCodeStr5] = useState(null);

    //------------------------FUNCTIONS----------------------------------------------------------
    const onSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let formData = getFormData(e.target, {
            rawCol: {
                code1: true,
                code2: true,
                code3: true,
                code4: true,
                code5: true,
                volume: true,
            },
        });

        if (!formData?.code1) {
					showToast(string.APP_ADMIN_ADD_SC_INPUT01_EMPTY_ERROR);
					focusElement('#code1');
					return;
        } else if (formData?.code1.length < 6) {
					showToast(string.APP_ADMIN_ADD_SC_INPUT01_LENGTH_ERROR);
					focusElement('#code1');
					return;
				}
        if (!formData?.code2) {
					showToast(string.APP_ADMIN_ADD_SC_INPUT02_EMPTY_ERROR);
					focusElement('#code2');
					return;
				} else if (formData?.code2.length < 4) {
					showToast(string.APP_ADMIN_ADD_SC_INPUT02_LENGTH_ERROR);
					focusElement('#code2');
					return;
				}
        if (!formData?.code3) {
					showToast(string.APP_ADMIN_ADD_SC_INPUT03_EMPTY_ERROR);
					focusElement('#code3');
					return;
				} else if (formData?.code3.length < 4) {
					showToast(string.APP_ADMIN_ADD_SC_INPUT03_LENGTH_ERROR);
					focusElement('#code3');
					return;
				}
        if (!formData?.code4) {
					showToast(string.APP_ADMIN_ADD_SC_INPUT04_EMPTY_ERROR);
					focusElement('#code4');
					return;
				} else if (formData?.code4.length < 4) {
					showToast(string.APP_ADMIN_ADD_SC_INPUT04_LENGTH_ERROR);
					focusElement('#code4');
					return;
				}
        if (!formData?.code5) {
					showToast(string.APP_ADMIN_ADD_SC_INPUT05_EMPTY_ERROR);
					focusElement('#code5');
					return;
				} else if (formData?.code5.length < 4) {
					showToast(string.APP_ADMIN_ADD_SC_INPUT05_LENGTH_ERROR);
					focusElement('#code5');
					return;
				}
        const parsedVolume = parseInt(formData?.volume, 10);
        if (!formData?.volume) {
            showToast(string.APP_ADMIN_ADD_SC_INPUT06_EMPTY_ERROR);
            focusElement('#volume');
            return;
        } else if (parsedVolume < 1) {
					showToast(string.APP_ADMIN_ADD_SC_INPUT06_ERROR);
					focusElement('#volume');
					return;
				}

        const formattedCode = `${formData?.code1.toUpperCase()}${formData?.code2.toUpperCase()}${formData?.code3.toUpperCase()}${formData?.code4.toUpperCase()}${formData?.code5.toUpperCase()}`;
        let Data = {
            code: formattedCode,
            volume: parsedVolume
        };
        showConfirm({
            body: string.APP_ADMIN_ADD_SC_ADD_CONFIRM,
            defaultAction: () => {
                sendPost({
                    url: Urls.servicecode.addcode,
                    body: Data,
                }).then((res) => {
									showToast(string.APP_ADMIN_ADD_SC_ADD_SUCCESS, 'success');
									onUpdated(res);
								}).catch((e) => {

								});
            },
        });
    };
    const onCode1Changed = (e) => {
        // console.log('onCode1Changed' + e.target.value);
        const code = e.target.value;
        if (code.length > 5) {
            focusElement('#code2');
        }
    };
    const onCode2Changed = (e) => {
        // console.log('onCode1Changed' + e.target.value);
        const code = e.target.value;
        if (code.length > 3) {
            focusElement('#code3');
        }
    };
    const onCode3Changed = (e) => {
        // console.log('onCode2Changed');
        const code = e.target.value;
        if (code.length > 3) {
            focusElement('#code4');
        }
    };
    const onCode4Changed = (e) => {
        // console.log('onCode3Changed');
        const code = e.target.value;
        if (code.length > 3) {
            focusElement('#code5');
        }
    };
    const onCode5Changed = (e) => {
        // console.log('onCode3Changed');
        const code = e.target.value;
        if (code.length > 3) {
            focusElement('#volume');
        }
    };

		useEffect(()=>{
			if(serviceCode !== null){
				return;
			}
			sendPost({
				url: Urls.servicecode.newcode,
			}).then((res) => {
				const { newCode } = res;
				let code = newCode;
				if(code.length === 22){
					code = getServiceCode(code);
				}
				// console.log(newCode);
				if(code.length === 26){
					setServiceCode(code);
					const codeStr = code.split('-');
					if(codeStr.length === 5){
						setCodeStr1(codeStr[0]);
						setCodeStr2(codeStr[1]);
						setCodeStr3(codeStr[2]);
						setCodeStr4(codeStr[3]);
						setCodeStr5(codeStr[4]);
					}
				}
			}).catch((e) => {
			});
			// eslint-disable-next-line react-hooks/exhaustive-deps
		},[ serviceCode ]);

    //------------------------------------RETURN---------------------------------------------------------
    return (
        <>
            <Page
                title={nNU(serviceCode) ? `${string.APP_ADMIN_ADD_SC_TITLE} [${serviceCode}]` : `${string.APP_ADMIN_ADD_SC_TITLE} [XXXXXX-YYYY-ZZZZ-TTTT-UUUU]`}
                body={
                    <>
                        <Form onSubmit={onSubmit}>
                            <FormControls
                                data={data}
                                controls={[
                                    {
                                        id: 'code1',
                                        title: string.APP_ADMIN_ADD_SC_INPUT01,
                                        maxlength: '6',
                                        onChange: onCode1Changed,
																				readOnly: nNU(serviceCode) ? true : false,
																				defaultValue: nNU(codeStr1) ? codeStr1 : '',
                                    },
                                    {
                                        id: 'code2',
                                        title: string.APP_ADMIN_ADD_SC_INPUT02,
                                        maxlength: '4',
                                        onChange: onCode2Changed,
																				readOnly: nNU(serviceCode) ? true : false,
																				defaultValue: nNU(codeStr2) ? codeStr2 : '',
                                    },
                                    {
                                        id: 'code3',
                                        title: string.APP_ADMIN_ADD_SC_INPUT03,
                                        maxlength: '4',
                                        onChange: onCode3Changed,
																				readOnly: nNU(serviceCode) ? true : false,
																				defaultValue: nNU(codeStr3) ? codeStr3 : '',
                                    },
                                    {
                                        id: 'code4',
                                        title: string.APP_ADMIN_ADD_SC_INPUT04,
                                        maxlength: '4',
                                        onChange: onCode4Changed,
																				readOnly: nNU(serviceCode) ? true : false,
																				defaultValue: nNU(codeStr4) ? codeStr4 : '',
                                    },
                                    {
                                        id: 'code5',
                                        title: string.APP_ADMIN_ADD_SC_INPUT05,
                                        maxlength: '4',
                                        onChange: onCode5Changed,
																				readOnly: nNU(serviceCode) ? true : false,
																				defaultValue: nNU(codeStr5) ? codeStr5 : '',
                                    },
                                    {
                                        id: 'volume',
                                        title: string.APP_ADMIN_ADD_SC_INPUT06,
                                        // onChange: onCode4Changed,
																				defaultValue:1,
                                    },

                                ]}
                                footer={<></>}
                            />
                            {/* <Card.Title>{string.APP_PASSWORD_CHANGE}</Card.Title> */}
                            <Row className="form-button-row" id="submit">
                                <Button type="submit">
                                    {string.APP_ADMIN_ADD_SC_SUBMIT}
                                </Button>
                            </Row>
                        </Form>
                    </>
                }
            />
        </>
    );
};

export default ServiceCodeAdd;
